'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _document = require('redux/modules/document');

var _schoollevels = require('redux/modules/schoollevels');

var _chapter = require('redux/modules/chapter');

var _components = require('../../components');

var _reactLadda = require('react-ladda');

var _reactLadda2 = _interopRequireDefault(_reactLadda);

var _reactRouter = require('react-router');

var _Parser = require('../../helpers/Parser');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LessonSheet = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: false,
  promise: function promise(options) {
    var dispatch = options.store.dispatch,
        _options$params = options.params,
        documentId = _options$params.documentId,
        chapterId = _options$params.chapterId;


    return _promise2.default.all([dispatch((0, _document.load)(documentId)), dispatch((0, _chapter.load)(chapterId)), dispatch((0, _schoollevels.load)())]);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    schoolLevels: state.schoolLevels.data,
    chapter: state.chapter.data,
    document: state.document.data,
    saving: state.document.saving,
    uploadingImage: state.document.uploadingImage,
    uploadedImage: state.document.image,
    config: state.config
  };
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LessonSheet, _Component);

  function LessonSheet(props) {
    (0, _classCallCheck3.default)(this, LessonSheet);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LessonSheet.__proto__ || (0, _getPrototypeOf2.default)(LessonSheet)).call(this, props));

    _this.handleTextareaChange = function (event) {
      var document = _this.state.document;

      document.content = event.target.value;
      _this.setState({ document: document });
    };

    _this.handleSaveDocument = function () {
      _this.props.dispatch((0, _document.save)(_this.state.document));
    };

    _this.handleOpenImageUploadModal = function () {
      _this.uploadImageInput.click();
    };

    _this.handleCloseImageUploadModal = function () {
      _this.setState({
        imageUploadModalVisible: false,
        uploadedImage: undefined
      });
    };

    _this.handleImageUploadChange = function (event) {
      var data = new FormData();
      data.append('file', event.target.files[0]);
      _this.setState({
        imageUploadModalVisible: true
      });
      _this.props.dispatch((0, _document.uploadImage)({ documentId: _this.state.document._id, data: data }));
    };

    _this.state = {
      document: props.document,
      saving: props.saving,
      uploadingImage: false,
      uploadedImage: undefined,
      imageUploadModalVisible: false
    };
    return _this;
  }

  (0, _createClass3.default)(LessonSheet, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.document !== 'undefined') {
        var document = nextProps.document;

        this.setState({
          document: document,
          saving: nextProps.saving
        });
      }

      if (typeof nextProps.uploadingImage !== 'undefined') {
        this.setState({
          uploadingImage: nextProps.uploadingImage
        });
      }

      if (typeof nextProps.uploadedImage !== 'undefined') {
        navigator.clipboard.writeText('[image:' + nextProps.uploadedImage.filename + ']');
        this.setState({
          uploadedImage: nextProps.uploadedImage
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./LessonSheet.scss');
      var _state = this.state,
          document = _state.document,
          saving = _state.saving,
          uploadingImage = _state.uploadingImage,
          imageUploadModalVisible = _state.imageUploadModalVisible,
          uploadedImage = _state.uploadedImage;
      var _props = this.props,
          schoolLevels = _props.schoolLevels,
          chapter = _props.chapter,
          routeParams = _props.routeParams,
          config = _props.config;

      var schoolLevel = schoolLevels.find(function (level) {
        return level._id === routeParams.schoolLevelId;
      });

      var innerHTML = function innerHTML(html) {
        return _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _Parser.textToHtml)(document._id, html, config) } });
      };

      return _react2.default.createElement(
        'div',
        { className: styles.document },
        _react2.default.createElement('input', { type: 'file', className: styles.imageUploadInput, ref: function ref(input) {
            return _this2.uploadImageInput = input;
          }, onChange: this.handleImageUploadChange }),
        imageUploadModalVisible && _react2.default.createElement(
          _components.Modal,
          { saving: uploadingImage, className: styles.imageUploadModal, onClose: this.handleCloseImageUploadModal },
          uploadedImage && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              null,
              'Code de l\'image \xE0 copier'
            ),
            _react2.default.createElement('textarea', { disabled: true, value: '[image:' + uploadedImage.filename + ']' })
          ),
          uploadingImage && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              null,
              'Import de l\'image en cours...'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.newDocumentToolbar },
          _react2.default.createElement(
            'span',
            { className: styles.breadcrumb },
            _react2.default.createElement(
              _reactRouter.Link,
              { activeClassName: styles.activeItem, className: styles.breadcrumbLink, to: '/schoollevels/' + schoolLevel._id },
              schoolLevel.name
            ),
            '\xA0\xA0>\xA0\xA0',
            _react2.default.createElement(
              _reactRouter.Link,
              { activeClassName: styles.activeItem, className: styles.breadcrumbLink, to: '/schoollevels/' + schoolLevel._id + '/chapters/' + chapter._id },
              chapter.title
            ),
            '\xA0\xA0>\xA0\xA0',
            document.title
          ),
          _react2.default.createElement(
            'button',
            { className: styles.documentSaveButton, onClick: this.handleOpenImageUploadModal },
            'Importer une image'
          ),
          _react2.default.createElement(
            _reactLadda2.default,
            { className: styles.documentSaveButton,
              'data-style': 'slide-down',
              loading: saving, onClick: this.handleSaveDocument },
            _react2.default.createElement(
              'span',
              null,
              'Enregistrer'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          innerHTML(document.content)
        ),
        _react2.default.createElement(
          'div',
          { className: styles.contentTextArea },
          _react2.default.createElement(
            'textarea',
            { onChange: this.handleTextareaChange },
            document.content.replace(/<br\s*\/?>/mg, '\n')
          )
        )
      );
    }
  }]);
  return LessonSheet;
}(_react.Component), _class2.propTypes = {
  schoolLevels: _react.PropTypes.array.isRequired,
  chapter: _react.PropTypes.object.isRequired,
  document: _react.PropTypes.object.isRequired,
  saving: _react.PropTypes.bool.isRequired,
  dispatch: _react.PropTypes.func.isRequired,
  routeParams: _react.PropTypes.object.isRequired,
  config: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class);
exports.default = LessonSheet;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/LessonSheet/LessonSheet.js
// module id = 1188
// module chunks = 0